import { connect } from 'react-redux';
import { loadDeviation, fullscreenEntered, fullscreenExited, setScreenSize, } from './redux/actions';
import { getEffectiveViewMode } from './redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    viewMode: getEffectiveViewMode(state, ownProps.deviation),
}); };
var mapDispatchToProps = {
    onLoad: loadDeviation,
    onFullscreenEntered: fullscreenEntered,
    onFullscreenExited: fullscreenExited,
    onScreenResize: setScreenSize,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DeviationPage.container.js.map